<template>
    <div style="min-height: 300px">
        <div style="margin-bottom: 20px;">
            <a-button @click="module.visible = true" icon="plus" type="primary">添加权限</a-button>
        </div>
        <a-table :columns="columns"
                 row-key="id"
                 :pagination="tableRelevant.tablePagination"
                 :loading="tableRelevant.tableLoading"
                 :scroll="{y: 400}"
                 :locale="tableRelevant.locale"
                 :dataSource="tableRelevant.tableDataSource">
            <span slot="customTitle">编码
                <a-popover title="提示">
                    <template slot="content">
                      <p>模块权限【查看】为必须，且编码字符必须有【View】</p>
                    </template>
                    <a-icon type="question-circle" />
                </a-popover>
            </span>
            <span slot="enabled" slot-scope="text, record">
                <a-switch @change="tableEnabledChange(text)" v-model="text.enabled" checked-children="启用"
                          un-checked-children="禁用"/>
            </span>
            <div slot="action" slot-scope="text, record">
                <a @click="tableEdit(text)" style="margin-right: 10px">
                    <a-icon type="edit"/>
                    编辑</a>
                <a-popconfirm title="确认要删除此模块吗？" @confirm="tableDelete(text)" ok-text="确认"
                              cancel-text="取消">
                    <a style="margin-right: 10px;color: #f5222d;">
                        <a-icon type="delete"/>
                        删除</a>
                </a-popconfirm>
            </div>
        </a-table>

        <a-modal v-model="module.visible"
                 :centered="true"
                 :destroyOnClose="true"
                 :title="module.title"
                 :confirm-loading="module.confirmLoading"
                 @cancel="moduleCancel"
                 @ok="moduleOk" width="500px">
            <a-form-model ref="authorizeForm"
                          :model="module.data"
                          :rules="module.rules"
                          :labelCol="{ span: 6 }"
                          :wrapperCol="{ span: 15 }">
                <a-form-model-item label="权限名称" prop="name">
                    <a-input v-model="module.data.name" placeholder="请输入权限名称" @blur="e => module.data.name = e.target.value.replace(/\s*/g, '')"/>
                </a-form-model-item>
                <a-form-model-item label="功能编码" prop="code">
                    <a-input v-model="module.data.code" placeholder="请输入功能编码" @blur="e => module.data.code = e.target.value.replace(/\s*/g, '')"/>
                </a-form-model-item>
                <a-form-model-item label="权限">
                    <a-select v-model="module.data.authorityType" placeholder="请选择机构" disabled>
                        <a-select-option :value="0">功能权限</a-select-option>
                        <a-select-option :value="1">数据权限</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="描述">
                    <a-textarea v-model="module.data.remark"
                            placeholder="请输入描述"
                            :auto-size="{ minRows: 2, maxRows: 4 }"/>
                </a-form-model-item>
                <a-form-model-item label="状态">
                    <a-radio-group v-model="module.data.enabled">
                        <a-radio :value="true">启用</a-radio>
                        <a-radio :value="false">禁用</a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {
            title: "名称",
            dataIndex: "name"
        },
        {
            dataIndex: "code",
            slots: { title: 'customTitle' },
        },
        {
            title: "描述",
            dataIndex: "remark"
        },
        {
            title: "状态",
            scopedSlots: {customRender: "enabled"}
        },
        {
            title: "操作",
            scopedSlots: {customRender: "action"}
        }
    ];

    export default {
        name: "ItemSetting",
        props: {
            itemData: Object
        },
        data() {
            return {
                columns,
                tableRelevant: tableRelevant.call(this),
                //添加或编辑功能
                module: {
                    visible: false,
                    confirmLoading: false,
                    title: "添加功能",
                    data: {
                        id: undefined,
                        name: '',
                        code: '',
                        authorityType: 0,
                        remark: '',
                        enabled: true,
                        moduleId: '',
                        applicationId: this.$route.query.id
                    },
                    rules: {
                        name: [
                            {required: true, message: '请输入功能名称', trigger: 'blur'},
                            {min: 2, max: 20, message: '模块名称长度 2 到 20 个字符', trigger: 'blur'},
                        ],
                        code: [{required: true, message: "请输入功能编码", trigger: "blur"}],
                        authorityType: [{required: true, message: '请选择权限', trigger: 'change'}],
                    },
                }
            }
        },
        mounted() {
            this.getPageList();
            console.log(this.$route.query.id);
        },
        methods: {
            //获取功能列表
            getPageList(pageIndex) {
                const params = {
                    ModuleId: this.itemData.id,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize
                };
                this.tableRelevant.tableLoading = true;
                this.$http.moduleAuthorizeList(params).then(res => {
                    this.tableRelevant.tableLoading = false;
                    const { data } = res.data;
                    this.tableRelevant.tableDataSource = data.items;
                    this.tableRelevant.tablePagination.total = data.totalCount;
                    this.tableRelevant.tablePagination.current = data.pageIndex;
                });
            },
            //添加编辑确认
            moduleOk() {
                this.$refs.authorizeForm.validate(valid => {
                    if (valid) {
                        const Ajax = this.module.title === "添加功能" ? this.$http.addModuleAuthorize : this.$http.editModuleAuthorize;
                        this.module.data.moduleId = this.itemData.id;
                        this.module.confirmLoading = true;
                        Ajax(this.module.data).then(res => {
                            this.module.confirmLoading = false;
                                this.$message.success(res.data.message);
                                this.module.visible = false;
                                this.moduleCancel();
                                this.getPageList();
                           
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //添加编辑取消
            moduleCancel() {
                this.$refs.authorizeForm.resetFields();
                this.module.title = "添加功能";
                this.module.data = {
                    id: undefined,
                    name: '',
                    code: '',
                    authorityType: 0,
                    remark: '',
                    enabled: true,
                    moduleId: '',
                    applicationId: this.$route.query.id
                }
            },
            //启用禁用
            tableEnabledChange(record) {
                this.tableRelevant.tableLoading = true;
                this.$http.updateModuleAuthorize(record).then(res => {
                    this.tableRelevant.tableLoading = false;
                        this.$message.success('修改成功');
                  
                });
            },
            tableEdit(json){
                this.module.visible = true;
                this.module.title = "编辑功能";
                for (let key in this.module.data){
                    this.module.data[key] = json[key];
                }
                this.module.data.authorityType = 0;
            },
            tableDelete(record){
                this.tableRelevant.tableLoading = true;
                this.$http.deleteModuleAuthorize([record.id]).then(res => {
                    this.tableRelevant.tableLoading = false;
                        this.$message.success("删除成功");
                        this.getPageList();
                   
                });
            }
        }
    }
</script>

<style scoped>

</style>